import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableTieredLoyalty',
  initialState: false,
  reducers: {
    setEnableTieredLoyalty(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableTieredLoyalty } = slice.actions;

export default slice.reducer;
